import { productIndex, referenceId, validMappedProduct } from './productMapping';

export const normalizeDescription = value => String(value ?? '').normalize('NFC').trim().replace(/\s+/gu, ' ').toLowerCase();
const validId = value => /^[a-f\d]{24}$/i.test(String(value || ''));
export function structuralIssue(invoice) {
  const items = Array.isArray(invoice.items) ? invoice.items : [];
  const ids = items.map(item => referenceId(item?._id));
  if (!validId(invoice._id) || !items.length || ids.some(id => !validId(id)) || new Set(ids).size !== ids.length) return 'Structural repair required: persisted, unique invoice/item IDs are missing or ambiguous.';
  if (!['COG', 'The Bengal Craft'].includes(invoice.organization)) return 'Structural repair required: unknown organization.';
  if (invoice.__v !== undefined && (!Number.isSafeInteger(invoice.__v) || invoice.__v < 0)) return 'Structural repair required: invalid invoice version.';
  return '';
}
export function groupHistoricalItems(invoices, products) {
  const groups = new Map(); const index = productIndex(products);
  (invoices || []).forEach((invoice, invoiceIndex) => {
    const issue = structuralIssue(invoice);
    (Array.isArray(invoice.items) ? invoice.items : []).forEach((item, position) => {
      const description = normalizeDescription(item?.label);
      const key = JSON.stringify([invoice.organization || '', description]);
      if (!groups.has(key)) groups.set(key, { key, description: String(item?.label ?? '').trim().replace(/\s+/gu, ' ') || '(Missing description)', organization: invoice.organization || '', rows: [] });
      const product = validMappedProduct(item, invoice.organization, index);
      groups.get(key).rows.push({ key: `${invoiceIndex}:${position}`, invoice, item: item || {}, product, mapped: !!product, issue });
    });
  });
  return [...groups.values()].map(group => {
    const mapped = group.rows.filter(row => row.mapped).length;
    return { ...group, mapped, remaining: group.rows.length - mapped, invoices: new Set(group.rows.map(row => row.invoice._id)).size,
      quantity: group.rows.reduce((sum, row) => sum + (Number.isFinite(Number(row.item.qty)) ? Number(row.item.qty) : 0), 0),
      status: mapped === group.rows.length ? 'Mapped' : mapped ? 'Partially Mapped' : 'Unmapped' };
  });
}
export function mappingPlan(rows, product, remap = false) {
  if (!product || product.isActive !== true) throw new Error('Select an active product.');
  const invoices = new Map();
  rows.forEach(row => {
    if (row.issue || row.invoice.organization !== product.organization || (row.mapped && !remap)) throw new Error('Selection includes an ineligible item.');
    const id = referenceId(row.invoice._id);
    if (!invoices.has(id)) invoices.set(id, { invoiceId: row.invoice._id, invoiceNumber: row.invoice.invoiceNumber, expectedVersion: row.invoice.__v ?? 0, organization: row.invoice.organization, productId: product._id, rows: [] });
    invoices.get(id).rows.push({ itemId: row.item._id, originalProductId: referenceId(row.item.productId) || '', description: normalizeDescription(row.item.label), confirmRemap: !!row.item.productId && remap });
    // Invalid references also require deliberate confirmation to replace.
    if (row.item.productId && !remap) throw new Error('Replacing an existing reference requires explicit remapping.');
  });
  if (!invoices.size) throw new Error('Select eligible invoice items.');
  return [...invoices.values()];
}
